/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    aws_project_region: 'us-east-2',
    aws_cognito_identity_pool_id: 'us-east-2:fa2cb634-7019-4cf8-aa25-23a78f4f6d16',
    aws_cognito_region: 'us-east-2',
    aws_user_pools_id: 'us-east-2_rCNhDQsGm',
    aws_user_pools_web_client_id: '2bpcbq4mq0blfiuoacc02jb5ne',
    oauth: {
        domain: 'onesolutions-dev.auth.us-east-2.amazoncognito.com',
        scope: ['phone', 'email', 'openid', 'profile'],
        redirectSignIn: 'myapp://',
        redirectSignOut: 'myapp://',
        responseType: 'code',
    },
    federationTarget: 'COGNITO_USER_POOLS',
    aws_cognito_username_attributes: [],
    aws_cognito_social_providers: [],
    aws_cognito_signup_attributes: ['EMAIL'],
    aws_cognito_mfa_configuration: 'OFF',
    aws_cognito_mfa_types: ['SMS'],
    aws_cognito_password_protection_settings: {
        passwordPolicyMinLength: 8,
        passwordPolicyCharacters: [],
    },
    aws_cognito_verification_mechanisms: ['EMAIL'],
    aws_user_files_s3_bucket: 'dotsprojectdev-storage-fcc018c4110821-dev',
    aws_user_files_s3_bucket_region: 'us-east-2',
}

export default awsmobile
